import { FilterCountBadgeSlot } from "./FilterCountBadge.styled";

type FilterCountBadgeProps = {
  count: number;
};

function FilterCountBadge({ count }: FilterCountBadgeProps): JSX.Element {
  const active = count > 0;

  return (
    <FilterCountBadgeSlot
      className={active ? "active" : ""}
      aria-hidden={!active}
    >
      <span className="badge-content">{count}</span>
    </FilterCountBadgeSlot>
  );
}

export { FilterCountBadge };
